










import Vue from 'vue';

export default Vue.extend({
  props: ['value', 'disabled', 'stopPropagation'],
  methods: {
    onClickButton(e: Event) {
      if (this.stopPropagation) e.stopPropagation();
      this.$emit('onClickButton', e.target);
    },
  },
  computed: {
    computedClass(): {
      [Property in 'gray']: boolean;
    } {
      return this.disabled ? { gray: true } : { gray: false };
    },
  },
});
